import { Outlet } from "react-router-dom";
import {
  Layout,
  LayoutHeader,
  LayoutContent,
} from "@jana-technology/platform-ui";

import { NavbarContainer, RiskManagementNavTabs } from "components/navbar";
import { RiskSidebar } from "components/sidebar";
import { OutcomeScenariosProvider } from "contexts/scenarios";

export const RiskManagementLayout = () => {
  return (
    <OutcomeScenariosProvider>
      <Layout>
        <LayoutHeader>
          <NavbarContainer>
            <RiskManagementNavTabs />
          </NavbarContainer>
        </LayoutHeader>
        <LayoutContent sidebar={<RiskSidebar />} sidebarSize="sm">
          <Outlet />
        </LayoutContent>
      </Layout>
    </OutcomeScenariosProvider>
  );
};

export default RiskManagementLayout;
